<div class="w-full box-border flex flex-col gap-1">
    <!-- Canvas Context Indicator -->
    @if(message()['additional_kwargs']?.canvasName) {
    <div class="flex flex-col gap-3 ml-auto text-sm text-gray-600 mb-1">
        <div class="flex items-center justify-end gap-2">
            <app-icon [type]="'corner-down-right'" [source]="'lucide'" [size]="'sm'"></app-icon>
            <div>Asked Bob</div>
        </div>
        <div class="flex items-center gap-2 justify-end">
            <app-icon [type]="'corner-down-right'" [source]="'lucide'" [size]="'sm'" class="mr-0.5"></app-icon>
            <app-icon [type]="'file-text'" [source]="'lucide'" [size]="'sm'"></app-icon>
            <div>{{message()['additional_kwargs'].canvasName}}</div>
        </div>
    </div>
    }

    <!-- Attachments -->
    @if(message()['additional_kwargs']?.attachments?.length) {
    <div class="w-full">
        <app-attachment-group [attachments]="message()['additional_kwargs'].attachments" [maxVisibleAttachments]="6"
            [gridDirection]="'rtl'" [canRemove]="false" [canOpen]="true"
            (openAttachment)="onAttachmentOpen($event)"></app-attachment-group>
    </div>
    }

    <div class="flex flex-col gap-2">
        <div class="flex justify-end group w-full">

            <div class="user-message relative" [ngClass]="{'!max-w-[100%] !w-[100%]': isEditing()}">
                @if(!isEditing()) {
                <!-- View Mode -->
                <div class="flex flex-col justify-end items-end gap-1">
                    <div class="bg-secondary rounded-base w-fit overflow-hidden">

                        <!-- Message body — clamped when long and collapsed -->
                        <div class="message-body px-3 pt-3" [class.collapsed]="isLong() && isCollapsed()">
                            <div class="prose prose-base max-w-none"
                                [innerHTML]="message().content | markdownRender:isOwner()" dynamicComponentRenderer>
                            </div>
                        </div>

                        <!-- Toggle row — only shown for long messages -->
                        @if(isLong()) {
                        <div class="relative">
                            <div class="toggle-row flex justify-end px-3 pb-2 pt-1">
                                <button
                                    class="text-xs font-medium text-gray-500 hover:text-gray-800 flex items-center gap-1 transition-colors"
                                    (click)="toggleCollapse()">
                                    @if(isCollapsed()) {
                                    <app-icon type="chevron-down" source="lucide" size="xs" />
                                    Show more
                                    } @else {
                                    <app-icon type="chevron-up" source="lucide" size="xs" />
                                    Show less
                                    }
                                </button>
                            </div>
                        </div>
                        } @else {
                        <!-- Bottom padding for short messages -->
                        <div class="pb-2"></div>
                        }

                    </div>
                    <div class="flex items-center gap-1 justify-end">
                        <app-button (clicked)="copyMessage()" size="sm" [icon]="isCopied() ? 'check-check' : 'copy'"
                            pTooltip="Copy" tooltipPosition="bottom" iconSource="lucide" severity="contrast"
                            variant="ghost" />
                        @if(canEdit() && isOwner() && threadMessagesService.threadMetadataStatus() !==
                        THREAD_METADATA_STATUS.IN_PROGRESS) {
                        <app-button (clicked)="startEditing()" size="sm" icon="pencil" iconSource="lucide"
                            severity="contrast" variant="ghost" pTooltip="Edit" tooltipPosition="bottom" />
                        }
                    </div>
                </div>
                } @else {
                <!-- Edit Mode -->
                <div class="w-full border bg-secondary rounded-bob p-2">
                    <textarea [ngModel]="editedContent()" (ngModelChange)="editedContent.set($event)"
                        class="w-full min-h-[80px] rounded-bob border p-3 focus:outline  focus:border-transparent resize-none"
                        placeholder="Edit your message..." (keydown)="handleKeyDown($event)"
                        [attr.aria-label]="'Edit message content'">
          </textarea>
                    <div class="flex items-center justify-between gap-2">
                        <div class="flex items-center gap-1 text-gray-600">
                            <app-icon [type]="'info'" source="lucide" />
                            <span class="text-sm">
                                Editing this message will remove all the following messages.
                            </span>
                        </div>
                        <div class="flex items-center gap-2">
                            <app-button (clicked)="cancelEditing()" label="Cancel" severity="contrast"
                                variant="outlined" />
                            <app-button (clicked)="saveEdit()" [disabled]="!editedContent().trim()"
                                [enableThrottle]="true" label="Send" severity="primary" variant="filled" />
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- ── Enhanced Prompt accordion — shown after the message bubble ── -->
    @if (approvedEnhancement()) {
    <p-accordion [multiple]="false" styleClass="w-full custom-accordion mt-1 bg-transparent custom-accordion-embedded">
        <p-accordion-panel value="0">
            <p-accordion-header>
                <div class="flex items-center gap-2 w-full py-1">
                    <app-icon type="sparkles" source="lucide" size="sm" variant="theme"></app-icon>
                    <span class="text-sm font-medium flex-1 min-w-0 truncate">Enhanced
                        Prompt</span>
                    @if (!approvedEnhancement()?.prompt_id) {
                    <app-button (clicked)="$event.stopPropagation(); saveEnhancementToLibrary()" size="sm"
                        icon="bookmark-plus" iconSource="lucide" severity="primary" variant="ghost"
                        pTooltip="Save to Prompt Library" tooltipPosition="bottom" />
                    }
                </div>
            </p-accordion-header>
            <p-accordion-content>
                <div class="py-1">
                    <pre
                        class="streaming-args-container mx-1 mb-1 px-3 py-2 text-xs text-gray-600 bg-white/80 rounded-md overflow-x-auto max-h-40 overflow-y-auto font-mono whitespace-pre-wrap break-all border border-gray-200">{{ approvedEnhancement()!.markdown }}</pre>
                </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
    }
</div>
